<script lang="ts">
    import FormLayoutErrors from "./FormLayoutErrors.svelte";

    export let label = "";
    export let helpText = "";
    let labelFor = "";
    export { labelFor as for };
    export let required = false;
    export let errors: string[] = [];
    export let id: string | undefined = undefined;
    // Чтобы передать ключ перевода вместо текста, нужно передать namespace.
    export let namespace: string | undefined = undefined;

    // TODO: Это только для кастом формы. После редизайна убрать.
    export let gap: string | undefined = "";
</script>

<div class="gw-form-layout-item" style={`--gap: ${gap || "4px"}`} {id}>
    <div>
        <label for={labelFor} class="gw-form-layout-item__label">
            <span class="gw-form-layout-item__label-text">
                {label}
            </span>
            <span class="gw-form-layout-item__required">
                {#if required}
                    *
                {/if}
            </span>
        </label>
        {#if helpText}
            <span class="gw-form-layout-item__help-text">
                {helpText}
            </span>
        {/if}
    </div>
    <div class="gw-form-layout-item__input-container">
        <slot />
    </div>
    <FormLayoutErrors {namespace} {errors} />
</div>

<style lang="postcss">
    .gw-form-layout-item {
        display: flex;
        flex-direction: column;
        row-gap: var(--gap, 4px);
        width: 100%;

        &__label {
            display: flex;
            column-gap: 3px;
        }

        &__help-text {
            font-size: 1em;
            font-weight: 400;
            line-height: 1.25em;
            color: #8b8c9e;
        }

        &__label-text {
            font-size: 1em;
            font-weight: 500;
            line-height: 1.25em;
            color: #1d2939;
        }

        &__required {
            font-size: 0.875em;
            line-height: 1.2em;
            color: #f04438;
        }
    }
</style>
